<mat-form-field class="mxs-input" *ngIf="!formReadonlyMode"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden}"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'">
    <mat-label>{{getLabel() | translate}}</mat-label>
    <input [ngClass]="{'assignment-multi': selectionMode === 'multi'}"
           matInput
           [formControlName]="name"
           [errorStateMatcher]=errorService
           readonly
           [value]="displayValue"
           [required]="required"
           (click)="onAssignmentFieldClick()"/>
    <button *ngIf="isDisplayed()" matSuffix mat-icon-button type="button" aria-label="Clear"
            (click)="resetValue()">
        <mat-icon>clear</mat-icon>
    </button>
    <button matSuffix mat-icon-button type="button"
            (click)="onAssignmentFieldClick()"
            [disabled]="assignmentFormControl.disabled">
        <mat-icon>add</mat-icon>
    </button>
    <mat-hint>{{getHint() | translate}}</mat-hint>
    <mat-error *ngFor="let error of getValidationMessages(true)">
        {{getError(error) | translate}}
    </mat-error>
</mat-form-field>

<mat-list-item class="mxs-readonly" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden}">
    <div class="mxs-readonly_label">{{getLabel() | translate}}</div>
    <div class="mxs-readonly_input">{{getDisplayValue(displayValue)}}</div>
</mat-list-item>
